<template>
  <div class="main">
    <div class="wrapper">
      <div class="top">
        <el-button
          style="position: fixed; left: 10px; top: 10px"
          slot="reference"
          type="text"
          @click="back()"
        >
          ←Back</el-button
        >
        <el-button
          style="position: fixed; right: 150px; top: 10px"
          slot="reference"
          type="success"
          @click="postApproval(1, '')"
          >Approve</el-button
        >
        <el-popover width="300" v-model="visibleT">
          <p style="display: flex; flex-direction: column">
            <b>Comment</b>
            <el-input
              style="margin: 10px 0"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              placeholder="please enter content..."
              v-model="textarea"
            >
            </el-input>
          </p>
          <div style="text-align: right; margin: 0">
            <el-button
              type="danger"
              size="mini"
              @click="postApproval(2, textarea)"
              >submit
            </el-button>
          </div>
          <el-button
            style="position: fixed; right: 50px; top: 10px"
            slot="reference"
            type="danger"
            plain
            >Reject</el-button
          >
        </el-popover>
      </div>
      <div class="bottom">
        <div class="img">
          <pdf ref="pdf" v-for="i in numPages" :key="i" :src="url" :page="i">
          </pdf>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pdf from "vue-pdf";
export default {
  components: {
    pdf,
  },
  data() {
    return {
      baseurl: "/static/Attachment/",
      url: "",
      numPages: undefined,
      visibleT: false,
      textarea: "",
      page: "",
    };
  },
  methods: {
    back() {
      this.$router.replace({ name: "Project", params: { ID: this.page } });
    },
    openAlert(operate, content) {
      let alertmsg = "Successfully Rejected!";
      if (operate == 1) {
        alertmsg = "Successfully Approved!";
      }
      this.$alert(alertmsg, {
        confirmButtonText: "确定",
        callback: () => {
          this.page = content;
          if (this.page == 0) {
            this.$router.push({ path: "/ApprovalIndex/" });
          } else {
            this.$router.replace({
              name: "Project",
              params: { ID: this.page },
            });
          }
        },
      });
    },
    //#region 计算pdf页面总数
    getNumPages(pdfUrl) {
      let loadingTask = pdf.createLoadingTask(pdfUrl);
      loadingTask.promise
        .then((pdf) => {
          this.numPages = pdf.numPages;
        })
        .catch((err) => {
          console.error("pdf 加载失败", err);
        });
    },
    bindAttachment(projectID) {
      this.$api
        .get("/Project/GetApprovalAttachment", {
          projectID: projectID,
        })
        .then((res) => {
          if (res.data.status == true) {
            this.url = this.baseurl + res.data.content;
          } else {
            if (res.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
              return false;
            }
          }
        });
    },
    postApproval(operate, comment) {
      let projectID = this.page;
      this.textarea = "";
      this.$api
        .post("Project/BatchApproveProject", {
          projectID: [projectID],
          operate: operate,
          comment: comment,
        })
        .then((res2) => {
          if (res2.data.status == true) {
            this.openAlert(operate, res2.data.content);
          } else {
            if (res2.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res2.data.message,
              });
              return false;
            }
          }
          this.visibleT = false;
        });
    },
  },
  watch: {
    page(val) {
      this.bindAttachment(val);
    },
    url(val) {
      this.getNumPages(val);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.page = this.$route.params.projectID;
    });
  },
};
</script>

<style scoped>
.main {
  flex: 1;
}
.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 0 25px;
  box-sizing: border-box;
  flex-direction: column;
}
.wrapper .top {
  height: 50px;
  position: relative;
  display: flex;
  box-sizing: border-box;
  padding: 28px 0 22px 0;
  justify-content: space-between;
}
.wrapper .bottom {
  flex: 1;
  background: #fff;
  margin-top: 15px;
  overflow: hidden;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090, direction=120, strength=4);
  -moz-box-shadow: 2px 2px 10px #909090;
  -webkit-box-shadow: 2px 2px 10px #909090;
  box-shadow: 2px 2px 10px #909090;
}
.wrapper .bottom .img {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/Viewpdf.vue